module.exports = __webpack_public_path__ + "static/media/certified2.218e7fc5.png";